import type { Directive } from 'vue';

const tooltip: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    if (!binding.value) return;

    // Tooltip-Attribute für ein natives Tooltip setzen
    el.setAttribute('title', binding.value);

    // Zusätzliche Accessibility-Attribute
    el.setAttribute('aria-label', binding.value);
    el.setAttribute('data-tooltip', binding.value);
  },
  updated(el, binding) {
    if (binding.value) {
      el.setAttribute('title', binding.value);
      el.setAttribute('aria-label', binding.value);
      el.setAttribute('data-tooltip', binding.value);
    } else {
      el.removeAttribute('title');
      el.removeAttribute('aria-label');
      el.removeAttribute('data-tooltip');
    }
  }
};

export default tooltip;
